import * as moment from "moment-timezone";
import useCurrentResourceCentre from "./useCurrentResourceCentre";

const usePayrollAndAttendance = (): {
  isPayrollSubscribed: boolean;
} => {
  const rc = useCurrentResourceCentre();

  const subscription = rc?.subscription || {};
  const nepalToday = moment.tz("Asia/Kathmandu");

  const isSubscriptionValid =
    subscription.activeSubscription &&
    subscription.features?.payroll?.subscribed &&
    nepalToday.isBetween(
      moment(subscription.subscriptionStart),
      moment(subscription.subscriptionEnd),
      null,
      "[]"
    );

  const isPayrollSubscribed = isSubscriptionValid;

  return { isPayrollSubscribed };
};

export default usePayrollAndAttendance;
